module.exports = __webpack_public_path__ + "img/delivery-cropped.782e2d12.svg";